import styled from "styled-components";
import { useFeatureFlagEnabled } from "posthog-js/react";
import config from "../../config";
import matchingPolicy from "../../assets/role_relay_matching_policy.pdf";
import terms from "../../assets/role_relay_terms.pdf";

const TERMS_URL =
  "https://platform.rolerelay.com/docs/role_relay_terms_and_conditions.pdf";

// ────────────────────────────────────────────────
// Styled Components – small & consistent with sidebar LegalLinks
// ────────────────────────────────────────────────

const FooterContainer = styled.footer`
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.4;
  padding: 0.75rem 1.25rem 1rem;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
  margin-top: auto;
  background: transparent;
`;

const Copyright = styled.div`
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.4rem;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.6rem;
  align-items: center;
`;

const LegalLink = styled.a`
  color: #227b7e;
  text-decoration: none;
  transition: color 140ms ease;

  &:hover {
    color: #0f4d4f;
    text-decoration: underline;
  }
`;

const Separator = styled.span`
  color: #94a3b8;
  user-select: none;
`;

const FeedbackLink = styled.span`
  cursor: pointer;
  color: #227b7e;
  transition: color 140ms ease;

  &:hover {
    color: #0f4d4f;
    text-decoration: underline;
  }
`;

// ────────────────────────────────────────────────
// Updated Footer Component
// ────────────────────────────────────────────────

const Footer = () => {
  const showSurveyFlag = useFeatureFlagEnabled(
    config?.postHog?.featureFlags?.showFeedbackSurvey
  );

  return (
    <FooterContainer>
      <Copyright>© {new Date().getFullYear()} Role Relay</Copyright>

      <LinksContainer>
        <LegalLink href={terms} target="_blank" rel="noreferrer">
          Terms
        </LegalLink>
        <Separator>•</Separator>

        <LegalLink href="/privacy" target="_blank" rel="noreferrer">
          Privacy
        </LegalLink>
        <Separator>•</Separator>

        <LegalLink href="/dispute" target="_blank" rel="noreferrer">
          Dispute
        </LegalLink>
        <Separator>•</Separator>

        <LegalLink href={matchingPolicy} target="_blank" rel="noreferrer">
          Matching
        </LegalLink>

        {showSurveyFlag && (
          <>
            <Separator>•</Separator>
            <FeedbackLink className="load-feedback-role-relay">
              Feedback
            </FeedbackLink>
          </>
        )}
      </LinksContainer>
    </FooterContainer>
  );
};

export default Footer;